import React from 'react';
import classNames from 'classnames';

// Todo: Properly migrate all of these types from Vanilla JS to TypeScript.
interface RowProps {
  granola?: any;
  children?: React.ReactNode;
  chonky?: any;
  mdCenter?: any;
  [key: string]: any; // Any other props
}

const Row = ({ granola, children, chonky, mdCenter, ...props }: RowProps) => (
  <div
    {...props}
    className={classNames('row', {
      'center-md': mdCenter,
      'row-chonky': chonky,
      'row-granola': granola,
    })}
  >
    {children}
  </div>
);

export default Row;
